import React from 'react';
import { Icon } from './Icon.js';
export const IconCaretUpToLineFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M14.75,2H3.25c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75H14.75c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M10.478,5.93c-.323-.509-.875-.812-1.478-.812s-1.155,.304-1.478,.812L2.84,13.313c-.341,.539-.362,1.222-.055,1.781s.895,.906,1.533,.906H13.682c.638,0,1.226-.347,1.533-.906s.287-1.242-.055-1.781l-4.682-7.383Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCaretUpToLineFill18.js.map